import React from 'react';
import { Box, Typography } from '@mui/material';
import { Bolt as FlashIcon } from '@mui/icons-material';
import { instaQuizPageSx, INSTA_QUIZ } from './instaQuizTheme';

const InstaQuizShell = ({
  children,
  onBack,
  title = 'Insta Quiz',
  showHeader = true,
  centered = true,
}) => (
  <Box sx={{ ...instaQuizPageSx, display: 'flex', flexDirection: 'column' }}>
    {/* Ambient glow orbs */}
    <Box
      sx={{
        position: 'absolute',
        top: '10%',
        left: '15%',
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(156,39,176,0.15) 0%, transparent 70%)',
        pointerEvents: 'none',
        animation: 'instaPulse 4s ease-in-out infinite',
        '@keyframes instaPulse': {
          '0%, 100%': { opacity: 0.6, transform: 'scale(1)' },
          '50%': { opacity: 1, transform: 'scale(1.08)' },
        },
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        bottom: '20%',
        right: '10%',
        width: 160,
        height: 160,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(224,64,251,0.1) 0%, transparent 70%)',
        pointerEvents: 'none',
      }}
    />

    {showHeader && (
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: { xs: 2, sm: 3 },
          py: 2,
        }}
      >
        {/* {onBack && (
          <IconButton
            onClick={onBack}
            sx={{
              color: '#fff',
              bgcolor: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.1)',
              '&:hover': { bgcolor: 'rgba(156,39,176,0.25)' },
            }}
          >
            <BackIcon />
          </IconButton>
        )} */}
        <FlashIcon sx={{ color: INSTA_QUIZ.purple, fontSize: 28 }} />
        <Typography variant="h6" sx={{ color: '#fff', fontWeight: 700, letterSpacing: 0.5 }}>
          {title}
        </Typography>
      </Box>
    )}

    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: centered ? 'center' : 'stretch',
        justifyContent: centered ? 'center' : 'flex-start',
        px: { xs: 2, sm: 3 },
        pb: 4,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default InstaQuizShell;
